//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Header, Accordion, MobileMenu } from '@cmp/common';
import CustomSectionContent from './CustomSection';
//------------------------------------------------------------------------------
// Data ------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import {
  AboutBackground,
  PatientBenefit,
  PatientBenefitResponsive,
} from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
import { keyValidate } from '@helpers/validation';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Support extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }

  render() {
    const componentClasses = classNames(styles.Support);
    const { toggle } = this.state;
    const { handleToggle } = this;
    const { t } = this.props;

    const section1title = (
      <>
        <span className={styles.SupportSectionTitle}>
          {t('support_Faq1Title')}
        </span>
      </>
    );
    const section1content = (
      <>
        <div className={styles.SupportContent}>
          {t('support_Faq1Text')} <br />
          <br />
          <span className={styles.SpanBold}>
            {t('support_Faq1Text_Ask_Your_Vet')}
          </span>
        </div>
      </>
    );
    const section2title = (
      <>
        <span className={styles.SupportSectionTitle}>
          {t('support_Faq2Title')}
        </span>
      </>
    );
    const section2content = (
      <>
        <div className={styles.SupportContent}>
          {t('support_Faq2Text')}
          {t('support_Faq2_2Text') != '' ? (
            <>
              <br />
              <br />
            </>
          ) : (
            <></>
          )}
          {t('support_Faq2_2Text')}
          <br />
          <br />
          {t('support_Faq2Text_Only_At')}
        </div>
      </>
    );
    const section3title = (
      <>
        <span className={styles.SupportSectionTitle}>
          {t('support_Faq3Title')}
        </span>
      </>
    );

    const section3content = (
      <CustomSectionContent {...this.props}></CustomSectionContent>
    );

    const section4title =
      t('support_Faq4Title') != '' ? (
        <>
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq4Title')}
          </span>
        </>
      ) : (
        ''
      );
    const section4content =
      t('support_Faq4Text1') != '' ? (
        <>
          <div className={styles.SupportContent}>
            {t('support_Faq4Text1')}
            <br />
            <br />
            {t('support_Faq4Text2')}
            {t('support_Faq4Text2_1') != '' ? (
              <>
                <br />
                <br />
              </>
            ) : (
              <></>
            )}
            {t('support_Faq4Text2_1')}
            {t('support_Faq4Text2_2') != '' ? (
              <>
                <br />
                <br />
              </>
            ) : (
              <></>
            )}
            {t('support_Faq4Text2_2')}
          </div>
        </>
      ) : (
        ''
      );

    const section5title = keyValidate('support_Faq5Title') ? (
      <>
        <span className={styles.SupportSectionTitle}>
          {t('support_Faq5Title')}
        </span>
      </>
    ) : (
      ''
    );
    const contentSection5Li = ['support_Faq5Text1li1', 'support_Faq5Text1li2'];
    const section5content = keyValidate('support_Faq5Text1') ? (
      <>
        <div className={styles.SupportContent}>
          {t('support_Faq5Text1')}
          <div className={styles.UlDiv}>
            <ul>
              {contentSection5Li.map((key) => {
                return keyValidate(key) ? <li>{t(key)}</li> : '';
              })}
            </ul>
            <br />
          </div>
        </div>
      </>
    ) : (
      ''
    );

    const section6title = keyValidate('support_Faq6Title') ? (
      <>
        <span className={styles.SupportSectionTitle}>
          {t('support_Faq6Title')}
        </span>
      </>
    ) : (
      ''
    );
    const contentSection6Li = [
      'support_Faq6Text1li1',
      'support_Faq6Text1li2',
      'support_Faq6Text1li3',
      'support_Faq6Text1li4',
    ];
    const contentSection6Li2 = [
      'support_Faq6Text2li1',
      'support_Faq6Text2li2',
      'support_Faq6Text2li3',
      'support_Faq6Text2li4',
    ];
    const section6content = keyValidate('support_Faq6Text1') ? (
      <>
        <div className={styles.SupportContent}>
          {t('support_Faq6Text1')}
          <div className={styles.UlDiv}>
            <ul>
              {contentSection6Li.map((key) => {
                return keyValidate(key) ? <li>{t(key)}</li> : '';
              })}
            </ul>
            <br />
          </div>
          {t('support_Faq6Text2')}
          <div className={styles.UlDiv}>
            <ul>
              {contentSection6Li2.map((key) => {
                return keyValidate(key) ? <li>{t(key)}</li> : '';
              })}
            </ul>
            <br />
          </div>
        </div>
      </>
    ) : (
      ''
    );

    const section7title = keyValidate('support_Faq7Title') ? (
      <>
        <span className={styles.SupportSectionTitle}>
          {t('support_Faq7Title')}
        </span>
      </>
    ) : (
      ''
    );
    const contentSection7Li = ['support_Faq7Text1li1', 'support_Faq7Text1li2'];
    const section7content = keyValidate('support_Faq7Text1') ? (
      <>
        <div className={styles.SupportContent}>
          {t('support_Faq7Text1')}
          <div className={styles.UlDiv}>
            <ul>
              {contentSection7Li.map((key) => {
                return keyValidate(key) ? <li>{t(key)}</li> : '';
              })}
            </ul>
            <br />
          </div>
        </div>
      </>
    ) : (
      ''
    );

    const faqsMocks = [
      {
        title: section1title,
        text: section1content,
      },
      {
        title: section2title,
        text: section2content,
      },
      {
        title: section3title,
        text: section3content,
      },
      {
        title: section4title,
        text: section4content,
      },
      {
        title: section5title,
        text: section5content,
      },
      {
        title: section6title,
        text: section6content,
      },
      {
        title: section7title,
        text: section7content,
      },
    ];

    return (
      <div className={componentClasses}>
        <Helmet>
          <title>{t('support_Support')}</title>
        </Helmet>

        <Header toggle={toggle} onToggle={handleToggle} />
        {toggle ? (
          <div className={styles.ContentMobile}>
            <MobileMenu />
          </div>
        ) : (
          <div className={styles.SupportMain}>
            <h1 className={styles.SupportMainTitle}>{t('support_Support')}</h1>
            <div className={styles.Content}>
              <div className={styles.Left}>
                <div className={styles.SupportInfo}>
                  <h2 className={styles.CallUs}>{t('support_CallUs')}</h2>
                  <p className={styles.Text}>{t('support_CallUsText')}</p>
                  <h3 className={styles.Number}>{t('support_CallUsNumber')}</h3>
                  <h3 className={styles.Time}>{t('support_CallUsTime')}</h3>
                </div>
              </div>
              <div className={styles.Right}>
                <div className={styles.SupportFaqs}>
                  <h3 className={styles.FaqsTitle}>{t('support_Faqs')}</h3>
                  {faqsMocks.map((faq, index) =>
                    faq.text && faq.title ? (
                      <Accordion
                        key={index}
                        title={faq.title}
                        text={faq.text}
                      />
                    ) : (
                      ''
                    )
                  )}
                  <p className={styles.SupportNote}>
                    {t('support_Note1')}
                    <a
                      href={t('support_NoteLink')}
                      className={styles.hreflink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('support_NoteLinkText')}
                    </a>
                    {t('support_Note2')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Support);
